/**
 * Root-relative paths to optimized WebP files in `public/img/`.
 * Regenerate with `npm run optimize:images` after replacing source PNGs.
 */
export const SPECIES_GATE_HERO = '/img/quiz-branding.webp';

export const SPECIES_GATE_DOG_THUMB = '/img/quiz-dog.webp';

export const SPECIES_GATE_CAT_THUMB = '/img/quiz-cat.webp';
